import { Component, OnInit } from '@angular/core';
import {LoadingController} from "@ionic/angular";
import {AuthService} from "../../service/auth.service";

@Component({
  selector: 'app-platforms',
  templateUrl: './platforms.page.html',
  styleUrls: ['./platforms.page.scss'],
})
export class PlatformsPage implements OnInit {


  ngOnInit() {
  }
  data: any = [];

  constructor(public loadingController: LoadingController,
              private authService: AuthService)
  {

  }




}
